import axios from "axios";
import * as qs from "qs";
import { message } from "antd";
import { getUrlHead } from "utils/enum/url";


const urlHead = getUrlHead();

// const env = process.env.NODE_ENV;
const REACT_APP_API_DOMAIN = process.env.REACT_APP_API_DOMAIN
//const _apiHost = process.env.REACT_APP_API_HOST;
const getAPIHost = () => {
  return REACT_APP_API_DOMAIN
};

// 配置后端接口地址
export const API_URL = getAPIHost();

const config = {
  // 基础url前缀
  baseURL: API_URL, //"http://mock.lanmaowork.com/mock/44/",
  // 请求头信息
  headers: {
    Accept: "application/json, text/plain, */*"
  },
  // 设置超时时间
  timeout: 10000,
  // 携带凭证
  withCredentials: true,
  // 返回数据类型
  responseType: "json",
  maxRedirects: 10
  // paramsSerializer: function(params) {
  //   return qs.stringify(params, { arrayFormat: "brackets" });
  // }
};

interface Ioptions {
  url: string;
  method: string;
  data?: any;
  params?: any; // 接口参数
  timeout?: any; //目前没有用到
  isShowError?: boolean; // 是否弹出提示框
}

// 重发次数
axios.defaults["retry"] = 0;
// 超时时间
axios.defaults["retryDelay"] = 30000;

export default function $axios({ url, method, data, params, timeout = 0, isShowError = true }: Ioptions) {
  return new Promise((resolve, reject) => {
    const instance = axios.create(config);

    // request 拦截器
    instance.interceptors.request.use(
      config => {
        // 1. 请求开始的时候可以结合 rematch 开启全屏 loading 动画
        console.log("准备发送请求...");
        let newParams: any = {};
        for (const item in params) {
          // 排除扩展的临时字段
          //参考 fromSource_extField1
          if (item.indexOf("_extField") == -1) {
            if (typeof params[item] === "string") {
              params[item] = params[item].trim();
            }
            newParams[item] = params[item];
          }
        }

        if (config.method === "post") {
          // 给字符串去空格
          config.params = null;
          config.data = qs.stringify(newParams);
        } else {
          config.params = newParams;
        }
        // config.data = qs.stringify(config.data);
        // //debugger;
        // 2. 根据请求方法，序列化传来的参数，根据后端需求是否序列化
        // if (config.method === "post") {
        //   config.headers = {
        //     "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
        //   };
        // }
        return config;
      },

      error => {
        // 请求错误时
        console.log("request:", error);
        // 1. 判断请求超时
        if (
          error.code === "ECONNABORTED" &&
          error.message.indexOf("timeout") !== -1
        ) {
          console.log("timeout请求超时");
          // return service.request(originalRequest);//再重复请求一次
        }
        // 2. 需要重定向到错误页面
        // const errorInfo = error.response;
        // console.log(errorInfo);
        // if (errorInfo) {
        //   //error = errorInfo.data  //页面那边catch的时候就能拿到详细的错误信息,看最下边的Promise.reject
        //   const errorStatus = errorInfo.status; // 404 403 500 ...
        //   router.push({
        //     path: `/error/${errorStatus}`
        //   });
        // }
        return Promise.reject(error); // 在调用的那边可以拿到(catch)你想返回的错误信息
      }
    );

    // response 拦截器
    instance.interceptors.response.use(
      response => {
        console.log("接送到的数据");
        let data;
        // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
        if (response.data == undefined) {
          data = JSON.parse(response.request.responseText);
        } else {
          data = response.data;
        }

        // 根据返回的code值来做不同的处理
        switch (data.code) {
          case "0000":
            console.log(data.msg);
            return data;
          case "1000":
            message.error(data.msg);
            return data;
          case "0001":
            console.log(data.msg);
            // message.error("操作失败");
            return data;
          case "1002":
            //console.log(data.msg);
            message.success(data.msg);
            return data;
          case "2000":
            message.config({
              top: 100,
              duration: 2,
              maxCount: 1
            });
            message.error("登录超时,2秒后将跳转");
            setTimeout(() => {
              window.location.href = urlHead + data.url;
            }, 2000);
            return data;
          // 没有权限访问
          case "2001":
            message.config({
              top: 100,
              duration: 2,
              maxCount: 1
            });
            message.error("没有权限访问");
            return {
              ...data,
              code: "0000",
              data: []
            };
          case null:
            // code = null 时的提示
            message.error("网络错误");
            return data;
          // case 0:
          //   store.commit("changeState");
          // // console.log('登录成功')
          default:
            if (data.data instanceof Array) {
              return data;
            } else {
              if (isShowError) {
                message.error(data.msg);
                return data;
              } else {
                return data
              }
            }
        }

        // 若不是正确的返回code，且已经登录，就抛出错误
        const err: any = new Error(data.msg);
        err.data = data;
        err.response = response;
        throw err;
      },
      err => {
        if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = "请求错误";
              break;

            case 401:
              err.message = "未授权，请登录";
              break;

            case 403:
              err.message = "拒绝访问";
              break;

            case 404:
              err.message = `请求地址出错: ${err.response.config.url}`;
              break;

            case 408:
              err.message = "请求超时";
              break;

            case 500:
              err.message = "服务器内部错误";
              break;

            case 501:
              err.message = "服务未实现";
              break;

            case 502:
              err.message = "网关错误";
              break;

            case 503:
              err.message = "服务不可用";
              break;

            case 504:
              err.message = "网关超时";
              break;

            case 505:
              err.message = "HTTP版本不受支持";
              break;

            default:
              break;
          }
        }
        console.error(err);
        return Promise.reject(err); // 返回接口返回的错误信息
      }
    );

    // 请求处理
    instance({
      url,
      method,
      data,
      params,
      timeout
    })
      .then(res => {
        resolve(res);
        return false;
      })
      .catch(error => {
        reject(error);
      });
  });
}
